(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1491],{

/***/ 27234:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ AccommodationBlock_AccommodationBlock; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ./src/components/models/accommodation/AccommodationBlock/AccommodationBlock.module.scss
var AccommodationBlock_module = __webpack_require__(58948);
var AccommodationBlock_module_default = /*#__PURE__*/__webpack_require__.n(AccommodationBlock_module);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(32758);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(73117);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(35363);
// EXTERNAL MODULE: ./src/components/cms/Title/index.tsx + 1 modules
var Title = __webpack_require__(31250);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next-i18next@12.0.1_@types+react@18.0.20_next@12.3.1_@babel+core@7.29.7_@types+react-do_eca48fcf8a6ebbff0d8681abd954f0c6/node_modules/next-i18next/dist/esm/index.js + 17 modules
var esm = __webpack_require__(84423);
// EXTERNAL MODULE: ./src/components/models/accommodation/AccommodationDetailed/AccommodationDetailed.module.scss
var AccommodationDetailed_module = __webpack_require__(51743);
var AccommodationDetailed_module_default = /*#__PURE__*/__webpack_require__.n(AccommodationDetailed_module);
// EXTERNAL MODULE: ./src/components/models/accommodation/AccommodationDetailed/AccommodationRoomType/AccommodationRoomType.module.scss
var AccommodationRoomType_module = __webpack_require__(10979);
var AccommodationRoomType_module_default = /*#__PURE__*/__webpack_require__.n(AccommodationRoomType_module);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/Card.js + 2 modules
var Card = __webpack_require__(48648);
// EXTERNAL MODULE: ./src/components/elements/media/CloudinaryImage/index.ts + 1 modules
var CloudinaryImage = __webpack_require__(42500);
// EXTERNAL MODULE: ./src/components/models/cms/blocks/TextWithImageBlock/TextWithImageSlider/index.tsx + 1 modules
var TextWithImageSlider = __webpack_require__(38975);
// EXTERNAL MODULE: ./src/app/providers/PrintConfigProvider.tsx
var PrintConfigProvider = __webpack_require__(3106);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
;// CONCATENATED MODULE: ./src/components/models/accommodation/AccommodationDetailed/AccommodationRoomType/AccommodationRoomType.tsx









var positions = [
    "left",
    "right"
];
var AccommodationRoomType = function(param) {
    var roomType = param.roomType, index = param.index;
    var printConfig = (0,react.useContext)(PrintConfigProvider/* PrintConfigContext */.E);
    var positionMD = positions[Math.floor(index % 2)];
    var positionXXL = positions[Math.floor(index / 2) % positions.length];
    if (printConfig.isPrint) {
        positionXXL = positionMD;
    }
    var imageComponent = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "box-ratio-16-9",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "box-ratio-inner ".concat((AccommodationRoomType_module_default()).imgWrap)
        })
    });
    if (roomType.gallery.images.length > 1 && !printConfig.isPrint) {
        imageComponent = /*#__PURE__*/ (0,jsx_runtime.jsx)(TextWithImageSlider/* default */.Z, {
            gallery: roomType.gallery
        });
    } else if (roomType.gallery.images[0]) {
        // simple image
        var image = roomType.gallery.images[0];
        imageComponent = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "box-ratio-16-9",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "box-ratio-inner ".concat((AccommodationRoomType_module_default()).imgWrap),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CloudinaryImage/* default */.Z, {
                        image: image,
                        width: 704,
                        aspectRatio: 1.777,
                        responsive: false,
                        className: "card-img d-lg-none"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CloudinaryImage/* default */.Z, {
                        image: image,
                        width: 704,
                        aspectRatio: 1.1,
                        responsive: false,
                        className: "card-img d-none d-xl-block"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CloudinaryImage/* default */.Z, {
                        image: image,
                        width: 704,
                        aspectRatio: 0.8,
                        responsive: false,
                        className: "card-img d-none d-lg-block d-xl-none"
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
        className: "".concat((AccommodationRoomType_module_default()).root, " h-100"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
            className: "h-100",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                    md: {
                        span: roomType.gallery.images.length > 0 ? 6 : 12,
                        order: positionMD === "left" ? "first" : "last"
                    },
                    xxl: {
                        span: roomType.gallery.images.length > 0 ? 6 : 12,
                        order: positionXXL === "left" ? "first" : "last"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Body */.Z.Body, {
                        className: (AccommodationRoomType_module_default()).cardBody,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Title */.Z.Title, {
                                className: (AccommodationRoomType_module_default()).cardTitle,
                                children: roomType.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Text */.Z.Text, {
                                dangerouslySetInnerHTML: {
                                    __html: roomType.description
                                }
                            })
                        ]
                    })
                }),
                roomType.gallery.images.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                    md: 6,
                    className: "".concat(positionMD === "left" ? "ps-md-0" : "pe-md-0", " ").concat(positionXXL === "left" ? "ps-xxl-0 pe-xxl-2" : "pe-xxl-0 ps-xxl-2"),
                    children: imageComponent
                })
            ]
        })
    });
};
/* harmony default export */ var AccommodationRoomType_AccommodationRoomType = (AccommodationRoomType);

;// CONCATENATED MODULE: ./src/components/models/accommodation/AccommodationDetailed/AccommodationRoomType/index.ts


// EXTERNAL MODULE: ./src/components/models/accommodation/AccommodationDetailed/AccommodationAvailableAddons/AccommodationAvailableAddons.module.scss
var AccommodationAvailableAddons_module = __webpack_require__(83927);
var AccommodationAvailableAddons_module_default = /*#__PURE__*/__webpack_require__.n(AccommodationAvailableAddons_module);
// EXTERNAL MODULE: ./src/components/models/cms/blocks/TextWithIconBlock/index.ts + 1 modules
var TextWithIconBlock = __webpack_require__(54872);
;// CONCATENATED MODULE: ./src/components/models/accommodation/AccommodationDetailed/AccommodationAvailableAddons/AccommodationAvailableAddons.tsx





var AccommodationAvailableAddons = function(param) {
    var addons = param.addons;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: addons.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                    className: "mb-3",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (AccommodationAvailableAddons_module_default()).title,
                            children: t("booking.additionalBookingOptions")
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                    children: addons.map(function(addon, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            className: "mb-3",
                            md: 6,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextWithIconBlock/* default */.Z, {
                                title: addon.name,
                                text: addon.description,
                                image: addon.icon
                            })
                        }, index);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var AccommodationAvailableAddons_AccommodationAvailableAddons = (AccommodationAvailableAddons);

;// CONCATENATED MODULE: ./src/components/models/accommodation/AccommodationDetailed/AccommodationAvailableAddons/index.ts


// EXTERNAL MODULE: ./src/components/models/media/GallerySlider/index.ts + 1 modules
var GallerySlider = __webpack_require__(85302);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(48417);
// EXTERNAL MODULE: ./src/components/elements/starRating/StarRatingDisplay/StarRatingDisplay.module.scss
var StarRatingDisplay_module = __webpack_require__(51912);
var StarRatingDisplay_module_default = /*#__PURE__*/__webpack_require__.n(StarRatingDisplay_module);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(71212);
;// CONCATENATED MODULE: ./src/components/elements/starRating/StarRatingDisplay/StarRatingDisplay.tsx





var StarRatingDisplay = function(param) {
    var starsValue = param.starsValue;
    var fullStar = /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: "".concat((StarRatingDisplay_module_default()).star),
        children: "★"
    });
    var halfStar = /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: "".concat((StarRatingDisplay_module_default()).star, " ").concat((StarRatingDisplay_module_default()).half),
        "data-forhalf": "★",
        children: "★"
    });
    // integer
    if ((0,helpers/* isInt */.GN)(Number(starsValue))) {
        var starsInt = Number(starsValue);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (StarRatingDisplay_module_default()).root,
            children: (0,_to_consumable_array/* default */.Z)(Array(starsInt)).map(function(item, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                    children: fullStar
                }, index);
            })
        });
    }
    // float
    if ((0,helpers/* isFloat */.Q7)(Number(starsValue))) {
        var fullStarsCount = Math.floor(Number(starsValue));
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (StarRatingDisplay_module_default()).root,
            children: [
                (0,_to_consumable_array/* default */.Z)(Array(fullStarsCount)).map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                        children: fullStar
                    }, index);
                }),
                halfStar
            ]
        });
    }
    // 5+
    if (starsValue === "5+") {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (StarRatingDisplay_module_default()).root,
            children: [
                (0,_to_consumable_array/* default */.Z)(Array(5)).map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                        children: fullStar
                    }, index);
                }),
                "+"
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var StarRatingDisplay_StarRatingDisplay = (StarRatingDisplay);

;// CONCATENATED MODULE: ./src/components/elements/starRating/StarRatingDisplay/index.ts


;// CONCATENATED MODULE: ./src/components/models/accommodation/AccommodationDetailed/AccommodationDetailed.tsx








var AccommodationDetailed = function(param) {
    var accommodation = param.accommodation, roomTypes = param.roomTypes, _detailed = param.detailed, detailed = _detailed === void 0 ? true : _detailed, _imagePosition = param.imagePosition, imagePosition = _imagePosition === void 0 ? "left" : _imagePosition;
    var mainImageComponent = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    if (accommodation.gallery.images.length) {
        mainImageComponent = /*#__PURE__*/ (0,jsx_runtime.jsx)(CloudinaryImage/* default */.Z, {
            image: accommodation.gallery.images[0],
            altDefault: accommodation.name,
            aspectRatio: 1.6,
            width: 1000,
            responsive: false,
            className: "card-img"
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                className: (AccommodationDetailed_module_default()).root,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                                className: "mb-5",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                    className: "h-100",
                                    children: imagePosition === "left" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                xl: 6,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "box-ratio-16-9",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "box-ratio-inner ".concat((AccommodationDetailed_module_default()).imgWrap),
                                                        children: mainImageComponent
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                xl: 6,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Body */.Z.Body, {
                                                    className: (AccommodationDetailed_module_default()).cardBody,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat((AccommodationDetailed_module_default()).stars, " clearfix"),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StarRatingDisplay_StarRatingDisplay, {
                                                                starsValue: accommodation.stars
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Title */.Z.Title, {
                                                            children: accommodation.name
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Text */.Z.Text, {
                                                            dangerouslySetInnerHTML: {
                                                                __html: accommodation.description
                                                            }
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                xl: 6,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Body */.Z.Body, {
                                                    className: (AccommodationDetailed_module_default()).cardBody,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat((AccommodationDetailed_module_default()).stars, " clearfix"),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StarRatingDisplay_StarRatingDisplay, {
                                                                starsValue: accommodation.stars
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Title */.Z.Title, {
                                                            children: accommodation.name
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Text */.Z.Text, {
                                                            dangerouslySetInnerHTML: {
                                                                __html: accommodation.description
                                                            }
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                xl: 6,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "box-ratio-16-9",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "box-ratio-inner ".concat((AccommodationDetailed_module_default()).imgWrap),
                                                        children: mainImageComponent
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    }),
                    detailed && /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                        className: "mb-4",
                        children: roomTypes.map(function(roomType, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                xxl: 6,
                                className: (AccommodationDetailed_module_default()).roomTypeWrap,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccommodationRoomType_AccommodationRoomType, {
                                    roomType: roomType,
                                    index: index
                                })
                            }, index);
                        })
                    }),
                    detailed && /*#__PURE__*/ (0,jsx_runtime.jsx)(AccommodationAvailableAddons_AccommodationAvailableAddons, {
                        addons: accommodation.availableAddons
                    })
                ]
            }),
            detailed && /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                fluid: true,
                className: (AccommodationDetailed_module_default()).galleryContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        className: "p-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GallerySlider/* default */.Z, {
                            gallery: accommodation.gallery,
                            trackingStringPrefix: "travel_page:accommodation_room_type_slider"
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var AccommodationDetailed_AccommodationDetailed = (AccommodationDetailed);

;// CONCATENATED MODULE: ./src/components/models/accommodation/AccommodationDetailed/index.ts


;// CONCATENATED MODULE: ./src/components/models/accommodation/AccommodationBlock/AccommodationBlock.tsx








function getVisibleRoomTypes(accommodationAssignment) {
    if (!accommodationAssignment.useCustomRoomTypeSelection) {
        return accommodationAssignment.accommodation.roomTypes;
    }
    // @ts-ignore
    var roomTypeIds = accommodationAssignment.roomTypeIds;
    return accommodationAssignment.accommodation.roomTypes.filter(function(roomType) {
        return !!(roomTypeIds === null || roomTypeIds === void 0 ? void 0 : roomTypeIds.includes(roomType.id));
    });
}
function getContent(accommodationAssignments) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: accommodationAssignments.map(function(accommodationAssignment, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccommodationDetailed_AccommodationDetailed, {
                    accommodation: accommodationAssignment.accommodation,
                    roomTypes: getVisibleRoomTypes(accommodationAssignment),
                    detailed: accommodationAssignment.displayDetails,
                    imagePosition: index % 2 === 0 ? "left" : "right"
                })
            }, index);
        })
    });
}
var AccommodationBlock = function(param) {
    var accommodationAssignments = param.accommodationAssignments;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    if (accommodationAssignments.length) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (AccommodationBlock_module_default()).root,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    className: "mb-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            id: "accommodation",
                            className: "anchor"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* TitleH2 */.W, {
                                    title: t(accommodationAssignments.length == 1 ? "travel.accommodation" : "travel.accommodations"),
                                    withDecoration: true
                                })
                            })
                        })
                    ]
                }),
                getContent(accommodationAssignments)
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var AccommodationBlock_AccommodationBlock = (AccommodationBlock);

;// CONCATENATED MODULE: ./src/components/models/accommodation/AccommodationBlock/index.tsx



/***/ }),

/***/ 35073:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ FullyBookedOverlay_FullyBookedOverlay; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/styled-jsx@5.0.7_@babel+core@7.29.7_babel-plugin-macros@3.1.0_react@18.2.0/node_modules/styled-jsx/style.js
var style = __webpack_require__(48692);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/Badge.js
var Badge = __webpack_require__(93232);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next-i18next@12.0.1_@types+react@18.0.20_next@12.3.1_@babel+core@7.29.7_@types+react-do_eca48fcf8a6ebbff0d8681abd954f0c6/node_modules/next-i18next/dist/esm/index.js + 17 modules
var esm = __webpack_require__(84423);
;// CONCATENATED MODULE: ./src/components/models/booking/BookingWizard/components/FullyBookedOverlay/FullyBookedOverlay.tsx




var FullyBookedOverlay = function(param) {
    var contingent = param.contingent;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            contingent === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "jsx-7a73a59a665a914c" + " " + "contingentErrorOverlay",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                    pill: true,
                    bg: "danger",
                    children: t("booking.fullyBooked")
                })
            }),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "7a73a59a665a914c",
                children: ".contingentErrorOverlay.jsx-7a73a59a665a914c{pointer-events:none;position:absolute;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;text-transform:uppercase;background:rgba(255,255,255,.8);width:100%;top:0;bottom:0;left:0;right:0}"
            })
        ]
    });
};
/* harmony default export */ var FullyBookedOverlay_FullyBookedOverlay = (FullyBookedOverlay);

;// CONCATENATED MODULE: ./src/components/models/booking/BookingWizard/components/FullyBookedOverlay/index.ts



/***/ }),

/***/ 91613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ContingentBadge_ContingentBadge; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ./src/components/models/booking/BookingWizard/steps/BookingStepAccommodation/ContingentBadge/ContingentBadge.module.scss
var ContingentBadge_module = __webpack_require__(16444);
var ContingentBadge_module_default = /*#__PURE__*/__webpack_require__.n(ContingentBadge_module);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/Badge.js
var Badge = __webpack_require__(93232);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next-i18next@12.0.1_@types+react@18.0.20_next@12.3.1_@babel+core@7.29.7_@types+react-do_eca48fcf8a6ebbff0d8681abd954f0c6/node_modules/next-i18next/dist/esm/index.js + 17 modules
var esm = __webpack_require__(84423);
;// CONCATENATED MODULE: ./src/components/models/booking/BookingWizard/steps/BookingStepAccommodation/ContingentBadge/ContingentBadge.tsx




var ContingentBadge = function(param) {
    var contingent = param.contingent, _className = param.className, className = _className === void 0 ? "" : _className;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: contingent <= 5 && contingent > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "d-block ".concat(className),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                bg: "warning",
                text: "dark",
                pill: true,
                className: (ContingentBadge_module_default()).badge,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                    children: t("booking.contingentWarning", {
                        count: contingent
                    })
                })
            })
        })
    });
};
/* harmony default export */ var ContingentBadge_ContingentBadge = (ContingentBadge);

;// CONCATENATED MODULE: ./src/components/models/booking/BookingWizard/steps/BookingStepAccommodation/ContingentBadge/index.ts



/***/ }),

/***/ 94012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ItineraryBlock_ItineraryBlock; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ./src/components/models/itinerary/ItineraryBlock/ItineraryBlock.module.scss
var ItineraryBlock_module = __webpack_require__(47937);
var ItineraryBlock_module_default = /*#__PURE__*/__webpack_require__.n(ItineraryBlock_module);
// EXTERNAL MODULE: ./src/components/models/itinerary/ItineraryAccordion/ItineraryAccordion.module.scss
var ItineraryAccordion_module = __webpack_require__(13625);
var ItineraryAccordion_module_default = /*#__PURE__*/__webpack_require__.n(ItineraryAccordion_module);
// EXTERNAL MODULE: ./src/components/elements/Accordion/index.ts + 1 modules
var Accordion = __webpack_require__(69894);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(73117);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(35363);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next-i18next@12.0.1_@types+react@18.0.20_next@12.3.1_@babel+core@7.29.7_@types+react-do_eca48fcf8a6ebbff0d8681abd954f0c6/node_modules/next-i18next/dist/esm/index.js + 17 modules
var esm = __webpack_require__(84423);
// EXTERNAL MODULE: ./src/components/elements/media/CloudinaryImage/index.ts + 1 modules
var CloudinaryImage = __webpack_require__(42500);
;// CONCATENATED MODULE: ./src/components/models/itinerary/ItineraryAccordion/ItineraryAccordion.tsx






var ItineraryAccordion = function(param) {
    var extendedItineraryItems = param.extendedItineraryItems, collapsed = param.collapsed;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    var colSizes = [
        1,
        3
    ];
    var items = extendedItineraryItems.map(function(item) {
        // date
        return {
            title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        md: colSizes[0],
                        className: "d-none d-md-block",
                        children: item.dayString
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        md: colSizes[1],
                        className: (ItineraryAccordion_module_default()).dateWrap,
                        children: item.dateString
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        className: "me-4",
                        children: item.title
                    })
                ]
            }),
            content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        md: colSizes[0] + colSizes[1],
                        className: (ItineraryAccordion_module_default()).imageCol,
                        children: item.image.publicId && /*#__PURE__*/ (0,jsx_runtime.jsx)(CloudinaryImage/* default */.Z, {
                            className: (ItineraryAccordion_module_default()).image,
                            image: item.image,
                            width: item.image.width >= item.image.height ? 200 : undefined,
                            height: item.image.width < item.image.height ? 200 : undefined,
                            altDefault: item.image.description,
                            aspectRatio: item.image.width >= item.image.height ? 1.777 : 0.562,
                            responsive: false
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        md: 12 - (colSizes[0] + colSizes[1]),
                        className: (ItineraryAccordion_module_default()).contentCol,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (ItineraryAccordion_module_default()).text,
                            dangerouslySetInnerHTML: {
                                __html: item.text
                            }
                        })
                    })
                ]
            })
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (ItineraryAccordion_module_default()).root,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "d-none d-md-block",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                    className: (ItineraryAccordion_module_default()).header,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            md: colSizes[0],
                            children: t("travel.itinerary.day")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            md: colSizes[1],
                            className: (ItineraryAccordion_module_default()).dateHeading,
                            children: t("travel.itinerary.date")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            children: t("travel.itinerary.program")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                items: items,
                className: "mb-3 ".concat((ItineraryAccordion_module_default()).accordion),
                collapsed: collapsed,
                trackingCategoryAndObject: "travel_page:itinerary_accordion_item"
            })
        ]
    });
};
/* harmony default export */ var ItineraryAccordion_ItineraryAccordion = (ItineraryAccordion);

;// CONCATENATED MODULE: ./src/components/models/itinerary/ItineraryAccordion/index.tsx


// EXTERNAL MODULE: ./src/components/cms/Title/index.tsx + 1 modules
var Title = __webpack_require__(31250);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(32758);
// EXTERNAL MODULE: ./src/components/models/travelExtension/TravelExtensionTeaser/index.ts + 1 modules
var TravelExtensionTeaser = __webpack_require__(76374);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(36690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(93089);
;// CONCATENATED MODULE: ./src/components/models/itinerary/functions.ts


// add dayString & dateString to itinerary items
var buildExtendedItineraryItems = function(itinerary, startDate, locale) {
    var prevDay = 0;
    var currentDay = 0;
    return itinerary.items.map(function(item) {
        prevDay = currentDay;
        currentDay += item.duration;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
            dayString: getDayString(prevDay, currentDay),
            dateString: getDateString(startDate, item.duration, prevDay, currentDay, locale)
        });
    });
};
function getDayString(prevDay, currentDay) {
    return prevDay === currentDay - 1 ? currentDay : "".concat(prevDay + 1, "-").concat(currentDay);
}
function getDateString(startDate, duration, prevDay, currentDay, locale) {
    if (locale === undefined) {
        locale = "de";
    }
    var formatDate = function(dateObject) {
        var year = dateObject.getUTCFullYear().toString().substr(-2);
        var month = ("0" + (dateObject.getUTCMonth() + 1)).slice(-2);
        var date = ("0" + dateObject.getUTCDate()).slice(-2);
        var day = dateObject.toLocaleDateString(locale, {
            weekday: "short",
            timeZone: "UTC"
        });
        return "".concat(day, ", ").concat(date, ".").concat(month, ".").concat(year);
    };
    var formatDateRange = function(startDate, endDate) {
        var start = startDate.toLocaleDateString(locale, {
            weekday: "short",
            timeZone: "UTC"
        });
        var end = endDate.toLocaleDateString(locale, {
            weekday: "short",
            timeZone: "UTC"
        });
        return "".concat(start, "-").concat(end);
    };
    var addDaysToDate = function(date, days) {
        var result = new Date(date);
        result.setUTCDate(result.getUTCDate() + days);
        return result;
    };
    var addDaysToDateValue = (prevDay === currentDay - 1 ? currentDay : prevDay + 1) - 1;
    var isRange = prevDay !== currentDay - 1;
    if (isRange) {
        var itemStartDate = addDaysToDate(startDate, addDaysToDateValue);
        var itemEndDate = addDaysToDate(startDate, addDaysToDateValue + (duration - 1));
        return formatDateRange(itemStartDate, itemEndDate);
    } else {
        var itemDate = addDaysToDate(startDate, addDaysToDateValue);
        return formatDate(itemDate);
    }
}

// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.1_@babel+core@7.29.7_@types+react-dom@18.0.6_@types+react@18.0.20_babel-plugi_4de291d6de77943be594741332b7d5bc/node_modules/next/router.js
var next_router = __webpack_require__(24826);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.1_@babel+core@7.29.7_@types+react-dom@18.0.6_@types+react@18.0.20_babel-plugi_4de291d6de77943be594741332b7d5bc/node_modules/next/dynamic.js
var dynamic = __webpack_require__(73802);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(71212);
;// CONCATENATED MODULE: ./src/components/models/itinerary/ItineraryBlock/ItineraryBlock.tsx











// import ItineraryMap from '@/components/models/itinerary/ItineraryMap'
var ItineraryMap = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6518), __webpack_require__.e(50)]).then(__webpack_require__.bind(__webpack_require__, 80050));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80050)
            ];
        }
    },
    ssr: false
});
var ItineraryBlock = function(param) {
    var travel = param.travel, collapsed = param.collapsed, _titleDecoration = param.titleDecoration, titleDecoration = _titleDecoration === void 0 ? false : _titleDecoration;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    var router = (0,next_router.useRouter)();
    var locale = router.locale;
    var hasExtension = false;
    var hasProgram = false;
    var content = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    var programSubjectToChange = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (ItineraryBlock_module_default()).programDisclaimer,
        children: t("travel.programSubjectToChange")
    });
    var extensions = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: travel.travelExtensions.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: "mt-5",
                    children: "Ferienverl\xe4ngerung"
                }),
                travel.travelExtensions.map(function(extension, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TravelExtensionTeaser/* default */.Z, {
                        extension: extension
                    }, index);
                })
            ]
        })
    });
    switch(travel.programType){
        case "TEXT":
            if (travel.programText) {
                hasProgram = true;
                content = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mb-3 ".concat((ItineraryBlock_module_default()).programText),
                            dangerouslySetInnerHTML: {
                                __html: travel.programText
                            }
                        }),
                        programSubjectToChange,
                        extensions
                    ]
                });
            } else if (travel.travelExtensions.length > 0) {
                hasExtension = true;
                content = extensions;
            }
            break;
        case "ITINERARY":
            // always start with the next upcoming travel date
            var getItineraryStartDate = function() {
                var ref;
                var startDate = new Date();
                if ((ref = travel.pricing) === null || ref === void 0 ? void 0 : ref.travels[0]) {
                    var pricingTravel = travel.pricing.travels[0];
                    // remove past dates
                    var dates = pricingTravel.dates.filter(function(date) {
                        return (0,helpers/* isFutureDate */.YI)(date.startDate) && !date.isHidden;
                    });
                    // remove extension dates
                    if (dates.length) {
                        dates = dates.filter(function(date) {
                            // @ts-ignore
                            return !date.includesExtension;
                        });
                    }
                    if (dates.length) {
                        startDate = (0,helpers/* stringDateToUTCDate */.PG)(dates[0].startDate);
                    } else {
                        // fallback to first date
                        startDate = (0,helpers/* stringDateToUTCDate */.PG)(travel.pricing.travels[0].dates[0].startDate);
                    }
                }
                return startDate;
            };
            var extendedItineraryItems = buildExtendedItineraryItems(travel.itinerary, getItineraryStartDate(), locale);
            if (extendedItineraryItems.length) {
                hasProgram = true;
                content = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                            xl: 8,
                            className: (ItineraryBlock_module_default()).accordionCol,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (ItineraryBlock_module_default()).accordionWrap,
                                    children: [
                                        travel.travelExtensions.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            children: "Hauptreise"
                                        }),
                                        travel.itinerary.items.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ItineraryAccordion_ItineraryAccordion, {
                                                    extendedItineraryItems: extendedItineraryItems,
                                                    collapsed: collapsed
                                                }),
                                                programSubjectToChange
                                            ]
                                        })
                                    ]
                                }),
                                extensions
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            className: (ItineraryBlock_module_default()).mapCol,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ItineraryMap, {
                                extendedItineraryItems: extendedItineraryItems
                            })
                        })
                    ]
                });
            } else if (travel.travelExtensions.length > 0) {
                hasExtension = true;
                content = extensions;
            }
            break;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: content && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            className: (ItineraryBlock_module_default()).root,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    id: "itinerary",
                    className: "anchor"
                }),
                hasProgram && /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* TitleH2 */.W, {
                            title: t("travel.itinerary.program"),
                            mb: 3,
                            withDecoration: titleDecoration
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                    className: "display-linebreak",
                    children: content
                })
            ]
        })
    });
};
/* harmony default export */ var ItineraryBlock_ItineraryBlock = (ItineraryBlock);

;// CONCATENATED MODULE: ./src/components/models/itinerary/ItineraryBlock/index.tsx



/***/ }),

/***/ 13673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ GalleryBlock_GalleryBlock; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ./src/components/models/travel/GalleryBlock/GalleryBlock.module.scss
var GalleryBlock_module = __webpack_require__(65385);
var GalleryBlock_module_default = /*#__PURE__*/__webpack_require__.n(GalleryBlock_module);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(32758);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(73117);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(35363);
// EXTERNAL MODULE: ./src/components/models/media/GallerySlider/index.ts + 1 modules
var GallerySlider = __webpack_require__(85302);
;// CONCATENATED MODULE: ./src/components/models/travel/GalleryBlock/GalleryBlock.tsx






var GalleryBlock = function(param) {
    var gallery = param.gallery;
    if (gallery.images.length) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            fluid: true,
            className: (GalleryBlock_module_default()).root,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    id: "gallery",
                    className: "anchor"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        className: "p-0 mb-5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GallerySlider/* default */.Z, {
                            gallery: gallery,
                            trackingStringPrefix: "cms_block:gallery"
                        })
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var GalleryBlock_GalleryBlock = (GalleryBlock);

;// CONCATENATED MODULE: ./src/components/models/travel/GalleryBlock/index.tsx



/***/ }),

/***/ 20576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ HeaderBlock_HeaderBlock; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/styled-jsx@5.0.7_@babel+core@7.29.7_babel-plugin-macros@3.1.0_react@18.2.0/node_modules/styled-jsx/style.js
var style = __webpack_require__(48692);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./src/components/models/travel/HeaderBlock/HeaderBlock.module.scss
var HeaderBlock_module = __webpack_require__(88372);
var HeaderBlock_module_default = /*#__PURE__*/__webpack_require__.n(HeaderBlock_module);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(32758);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(73117);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(35363);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next-i18next@12.0.1_@types+react@18.0.20_next@12.3.1_@babel+core@7.29.7_@types+react-do_eca48fcf8a6ebbff0d8681abd954f0c6/node_modules/next-i18next/dist/esm/index.js + 17 modules
var esm = __webpack_require__(84423);
// EXTERNAL MODULE: ./src/lib/helpers/travel.ts
var helpers_travel = __webpack_require__(27438);
// EXTERNAL MODULE: ./src/components/elements/media/ResponsiveHeaderImage/ResponsiveHeaderImage.module.scss
var ResponsiveHeaderImage_module = __webpack_require__(86539);
var ResponsiveHeaderImage_module_default = /*#__PURE__*/__webpack_require__.n(ResponsiveHeaderImage_module);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./src/components/elements/media/CloudinaryImage/index.ts + 1 modules
var CloudinaryImage = __webpack_require__(42500);
// EXTERNAL MODULE: ./src/components/elements/ImageGradientOverlay/index.tsx + 1 modules
var ImageGradientOverlay = __webpack_require__(66913);
// EXTERNAL MODULE: ./src/hooks/useBreakpoint.tsx
var useBreakpoint = __webpack_require__(54473);
;// CONCATENATED MODULE: ./src/components/elements/media/ResponsiveHeaderImage/ResponsiveHeaderImage.tsx



// import CloudinaryImageSrcSet from '@/components/elements/media/CloudinaryImageSrcSet'



var versions = [
    {
        name: "xs",
        height: 750,
        width: 576,
        aspectRatio: undefined
    },
    {
        name: "sm",
        height: 750,
        width: 768,
        aspectRatio: undefined
    },
    {
        name: "md",
        height: 800,
        width: 922,
        aspectRatio: undefined
    },
    {
        name: "lg",
        height: 800,
        width: 1200,
        aspectRatio: 1.125
    },
    {
        name: "xl",
        height: 750,
        width: 1400,
        aspectRatio: 1.315
    },
    {
        name: "xxl",
        height: 800,
        width: 1650,
        aspectRatio: 1.6
    },
    {
        name: "fhd",
        height: 750,
        width: 1920,
        aspectRatio: 1.821
    },
    {
        name: "uw",
        height: 750,
        width: 2560,
        aspectRatio: 2.45
    }, 
];
var isDefault = function(currentBreakpoint, imageBreakpoint) {
    if (currentBreakpoint) {
        return false;
    }
    if (imageBreakpoint === "xs") {
        return true;
    }
};
// const buildSet = (versions: { name: string; height: number; width: number; aspectRatio: number | undefined }[], withSidebar) => {
//   const set = versions.map((version) => {
//     return {
//       breakpoint: version.name,
//       height: version.height,
//       width: withSidebar && version.aspectRatio ? undefined : version.width,
//       aspectRatio: withSidebar && version.aspectRatio ? version.aspectRatio : undefined,
//     }
//   })
//   return set
// }
var ResponsiveHeaderImage = function(param) {
    var image = param.image, _lazyload = param.lazyload, lazyload = _lazyload === void 0 ? false : _lazyload, _withSidebar = param.withSidebar, withSidebar = _withSidebar === void 0 ? false : _withSidebar;
    var currentBreakpoint = (0,useBreakpoint/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (ResponsiveHeaderImage_module_default()).root,
        children: [
            versions.map(function(version, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                    children: (currentBreakpoint === version.name || isDefault(currentBreakpoint, version.name)) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CloudinaryImage/* default */.Z, {
                        image: image,
                        height: version.height,
                        width: withSidebar && version.aspectRatio ? undefined : version.width,
                        aspectRatio: withSidebar && version.aspectRatio ? version.aspectRatio : undefined,
                        lazyload: lazyload,
                        responsive: false,
                        placeholder: false
                    }, index)
                }, index);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageGradientOverlay/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var ResponsiveHeaderImage_ResponsiveHeaderImage = (ResponsiveHeaderImage);

;// CONCATENATED MODULE: ./src/components/elements/media/ResponsiveHeaderImage/index.ts


// EXTERNAL MODULE: ./src/components/models/travel/HeaderBlock/HeaderBlockInfoLabel/HeaderBlockInfoLabel.module.scss
var HeaderBlockInfoLabel_module = __webpack_require__(52604);
var HeaderBlockInfoLabel_module_default = /*#__PURE__*/__webpack_require__.n(HeaderBlockInfoLabel_module);
// EXTERNAL MODULE: ./src/components/elements/buttons/CustomButton/index.tsx + 1 modules
var CustomButton = __webpack_require__(75150);
;// CONCATENATED MODULE: ./src/components/models/travel/HeaderBlock/HeaderBlockInfoLabel/HeaderBlockInfoLabel.tsx



var HeaderBlockInfoLabel = function(param) {
    var label = param.label;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomButton/* default */.Z, {
        label: label,
        className: (HeaderBlockInfoLabel_module_default()).infoLabelCustomButton
    });
};
/* harmony default export */ var HeaderBlockInfoLabel_HeaderBlockInfoLabel = (HeaderBlockInfoLabel);

;// CONCATENATED MODULE: ./src/components/models/travel/HeaderBlock/HeaderBlockInfoLabel/index.tsx


;// CONCATENATED MODULE: ./src/components/models/travel/HeaderBlock/lib.ts
var buildSecondaryLabel = function(travel, t) {
    if (!travel.travelGuides.length) {
        return "";
    }
    var label = "".concat(t("with"), " ");
    travel.travelGuides.forEach(function(guide, index) {
        if (index > 0) {
            label += " ".concat(t("and"), " ");
        }
        label += "".concat(guide.firstName, " ").concat(guide.lastName);
    });
    return label;
};

;// CONCATENATED MODULE: ./src/components/models/travel/HeaderBlock/HeaderBlock.tsx









var HeaderBlock = function(param) {
    var travel = param.travel;
    var ref, ref1;
    var name = travel.name, mainImage = travel.mainImage, mainVideo = travel.mainVideo;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                fluid: true,
                className: (HeaderBlock_module_default()).root,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                    className: "h-100",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            xs: 4,
                            className: "gx-0 d-none d-lg-block ".concat((HeaderBlock_module_default()).tile)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            xs: 12,
                            lg: 8,
                            className: "gx-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveHeaderImage_ResponsiveHeaderImage, {
                                image: (mainVideo === null || mainVideo === void 0 ? void 0 : mainVideo.publicId) ? mainVideo : mainImage,
                                withSidebar: true
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "jsx-afeca152f81726ce" + " " + ((HeaderBlock_module_default()).content || ""),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: name
                                    },
                                    className: "jsx-afeca152f81726ce" + " " + ((HeaderBlock_module_default()).title || "")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    xs: 12,
                                    className: (HeaderBlock_module_default()).text,
                                    children: buildSecondaryLabel(travel, t)
                                }),
                                ((ref = travel.pricing) === null || ref === void 0 ? void 0 : (ref1 = ref.travels) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "jsx-afeca152f81726ce" + " " + ((HeaderBlock_module_default()).ribbonWrap || ""),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderBlockInfoLabel_HeaderBlockInfoLabel, {
                                        label: (0,helpers_travel/* buildTravelDatesLabel */.o6)(travel.pricing.travels, t)
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "afeca152f81726ce",
                children: "main{margin-top:0}"
            })
        ]
    });
};
/* harmony default export */ var HeaderBlock_HeaderBlock = (HeaderBlock);

;// CONCATENATED MODULE: ./src/components/models/travel/HeaderBlock/index.tsx



/***/ }),

/***/ 32367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ IntroBlock_IntroBlock; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ./src/components/models/travel/IntroBlock/IntroBlock.module.scss
var IntroBlock_module = __webpack_require__(89952);
var IntroBlock_module_default = /*#__PURE__*/__webpack_require__.n(IntroBlock_module);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(32758);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(73117);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(35363);
// EXTERNAL MODULE: ./src/components/models/travel/IntroBlock/IntroBlockLeadText/IntroBlockLeadText.module.scss
var IntroBlockLeadText_module = __webpack_require__(62100);
var IntroBlockLeadText_module_default = /*#__PURE__*/__webpack_require__.n(IntroBlockLeadText_module);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./src/components/elements/media/CloudinaryImage/index.ts + 1 modules
var CloudinaryImage = __webpack_require__(42500);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next-i18next@12.0.1_@types+react@18.0.20_next@12.3.1_@babel+core@7.29.7_@types+react-do_eca48fcf8a6ebbff0d8681abd954f0c6/node_modules/next-i18next/dist/esm/index.js + 17 modules
var esm = __webpack_require__(84423);
;// CONCATENATED MODULE: ./src/components/models/travel/IntroBlock/IntroBlockLeadText/IntroBlockLeadText.tsx





var IntroBlockLeadText = function(param) {
    var travel = param.travel;
    var title = travel.title, description = travel.description, partners = travel.partners;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (IntroBlockLeadText_module_default()).root,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (IntroBlockLeadText_module_default()).title,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (IntroBlockLeadText_module_default()).text,
                dangerouslySetInnerHTML: {
                    __html: description
                }
            }),
            travel.introVideoUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (IntroBlockLeadText_module_default()).videoWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                    className: (IntroBlockLeadText_module_default()).videoIframe,
                    src: travel.introVideoUrl,
                    title: "Travel Video",
                    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                    allowFullScreen: true
                })
            }),
            partners.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (IntroBlockLeadText_module_default()).partner,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (IntroBlockLeadText_module_default()).label,
                            children: t("travel.inCooperationWith")
                        }),
                        partners.map(function(partner, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                children: partner.logo.publicId ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (IntroBlockLeadText_module_default()).item,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloudinaryImage/* default */.Z, {
                                        style: {
                                            width: "".concat(partner.logoWidth || 50, "px")
                                        },
                                        width: partner.logoWidth || 50,
                                        image: partner.logo,
                                        responsive: false
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (IntroBlockLeadText_module_default()).item,
                                    children: partner.name
                                })
                            }, index);
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var IntroBlockLeadText_IntroBlockLeadText = (IntroBlockLeadText);

;// CONCATENATED MODULE: ./src/components/models/travel/IntroBlock/IntroBlockLeadText/index.tsx


// EXTERNAL MODULE: ./src/components/models/travel/IntroBlock/IntroBlockHighlights/IntroBlockHighlights.module.scss
var IntroBlockHighlights_module = __webpack_require__(43394);
var IntroBlockHighlights_module_default = /*#__PURE__*/__webpack_require__.n(IntroBlockHighlights_module);
;// CONCATENATED MODULE: ./src/components/models/travel/IntroBlock/IntroBlockHighlights/IntroBlockHighlights.tsx





var IntroBlockHighlights = function(param) {
    var highlights = param.highlights;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
        className: (IntroBlockHighlights_module_default()).root,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
            className: (IntroBlockHighlights_module_default()).inner,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (IntroBlockHighlights_module_default()).title,
                    children: t("travel.highlights")
                }),
                highlights.map(function(highlight, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: (IntroBlockHighlights_module_default()).list,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: highlight.text
                        })
                    }, index);
                })
            ]
        })
    });
};
/* harmony default export */ var IntroBlockHighlights_IntroBlockHighlights = (IntroBlockHighlights);

;// CONCATENATED MODULE: ./src/components/models/travel/IntroBlock/IntroBlockHighlights/index.tsx


;// CONCATENATED MODULE: ./src/components/models/travel/IntroBlock/IntroBlock.tsx







var IntroBlock = function(param) {
    var travel = param.travel;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (IntroBlock_module_default()).root,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            xl: 5,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IntroBlockHighlights_IntroBlockHighlights, {
                                highlights: travel.highlights
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IntroBlockLeadText_IntroBlockLeadText, {
                                travel: travel
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var IntroBlock_IntroBlock = (IntroBlock);

;// CONCATENATED MODULE: ./src/components/models/travel/IntroBlock/index.tsx



/***/ }),

/***/ 47766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ PricingBlock_PricingBlock; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ./src/themes/carreisen-ostschweiz/components/models/travel/PricingBlock/PricingBlock.module.scss
var PricingBlock_module = __webpack_require__(8174);
var PricingBlock_module_default = /*#__PURE__*/__webpack_require__.n(PricingBlock_module);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(32758);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(73117);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(35363);
// EXTERNAL MODULE: ./src/components/cms/Title/index.tsx + 1 modules
var Title = __webpack_require__(31250);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next-i18next@12.0.1_@types+react@18.0.20_next@12.3.1_@babel+core@7.29.7_@types+react-do_eca48fcf8a6ebbff0d8681abd954f0c6/node_modules/next-i18next/dist/esm/index.js + 17 modules
var esm = __webpack_require__(84423);
// EXTERNAL MODULE: ./src/themes/carreisen-ostschweiz/components/models/travel/PricingBlock/PricingBlockInfo/PricingBlockInfo.module.scss
var PricingBlockInfo_module = __webpack_require__(73587);
var PricingBlockInfo_module_default = /*#__PURE__*/__webpack_require__.n(PricingBlockInfo_module);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/Card.js + 2 modules
var Card = __webpack_require__(48648);
;// CONCATENATED MODULE: ./src/themes/carreisen-ostschweiz/components/models/travel/PricingBlock/PricingBlockInfo/PricingBlockInfo.tsx





var PricingBlockInfo = function(param) {
    var pricingTable = param.pricingTable, priceCalculationInfo = param.priceCalculationInfo;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
        xl: 5,
        className: (PricingBlockInfo_module_default()).root,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
            className: (PricingBlockInfo_module_default()).prices,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                className: "m-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                    className: (PricingBlockInfo_module_default()).inner,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (PricingBlockInfo_module_default()).pricingTableWrap,
                            dangerouslySetInnerHTML: {
                                __html: pricingTable
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (PricingBlockInfo_module_default()).pricingInfo,
                            children: priceCalculationInfo
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var PricingBlockInfo_PricingBlockInfo = (PricingBlockInfo);

;// CONCATENATED MODULE: ./src/components/models/travel/PricingBlock/PricingBlockInfo/index.tsx


// EXTERNAL MODULE: ./src/components/models/travel/PricingBlock/PricingBlockServices/PricingBlockServices.module.scss
var PricingBlockServices_module = __webpack_require__(78674);
var PricingBlockServices_module_default = /*#__PURE__*/__webpack_require__.n(PricingBlockServices_module);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
;// CONCATENATED MODULE: ./src/components/models/travel/PricingBlock/PricingBlockServices/PricingBlockServices.tsx





var PricingBlockServices = function(param) {
    var includedServices = param.includedServices, excludedServices = param.excludedServices, travel = param.travel;
    var ref, ref1, ref2, ref3;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    var furtherInformation = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    if (((ref = travel.pricing.tourOperator) === null || ref === void 0 ? void 0 : ref.name) && !((ref1 = travel.pricing.tourOperator) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.gtcPdf) === null || ref2 === void 0 ? void 0 : ref2.url)) {
        furtherInformation = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "mt-5",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (PricingBlockServices_module_default()).title,
                    children: t("travel.pricing.furtherInformation")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: t("travel.pricing.furtherInformationTextWithoutGtcLink", {
                        tourOperator: travel.pricing.tourOperator.name
                    })
                })
            ]
        });
    } else if ((ref3 = travel.pricing.tourOperator) === null || ref3 === void 0 ? void 0 : ref3.name) {
        furtherInformation = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "mt-5",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (PricingBlockServices_module_default()).title,
                    children: t("travel.pricing.furtherInformation")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Trans */.cC, {
                        i18nKey: "travel.pricing.furtherInformationTextWithGtcLink",
                        values: {
                            tourOperator: travel.pricing.tourOperator.name
                        },
                        children: [
                            "This tour is organized by our partner. The",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: travel.pricing.tourOperator.gtcPdf.url,
                                target: "_blank",
                                rel: "noreferrer",
                                children: "gtc"
                            }),
                            "of the tour operator apply."
                        ]
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (PricingBlockServices_module_default()).root,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (PricingBlockServices_module_default()).included,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (PricingBlockServices_module_default()).title,
                            children: t("travel.pricing.includedServices")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            dangerouslySetInnerHTML: {
                                __html: includedServices
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (PricingBlockServices_module_default()).title,
                    children: t("travel.pricing.excludedServices")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: excludedServices
                    }
                }),
                furtherInformation
            ]
        })
    });
};
/* harmony default export */ var PricingBlockServices_PricingBlockServices = (PricingBlockServices);

;// CONCATENATED MODULE: ./src/components/models/travel/PricingBlock/PricingBlockServices/index.tsx


;// CONCATENATED MODULE: ./src/components/models/travel/PricingBlock/PricingBlock.tsx









var PricingBlock = function(param) {
    var travel = param.travel;
    var includedServices = travel.includedServices, excludedServices = travel.excludedServices, pricingTable = travel.pricingTable, priceCalculationInfo = travel.priceCalculationInfo;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        fluid: true,
        className: (PricingBlock_module_default()).root,
        "data-tr-view": "travel_page:pricing_info:view",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    className: (PricingBlock_module_default()).container,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            id: "pricing",
                            className: "anchor"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* TitleH2 */.W, {
                                    title: t("travel.pricesAndServices"),
                                    className: (PricingBlock_module_default()).title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingBlockInfo_PricingBlockInfo, {
                                    pricingTable: pricingTable,
                                    priceCalculationInfo: priceCalculationInfo
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingBlockServices_PricingBlockServices, {
                                    includedServices: includedServices,
                                    excludedServices: excludedServices,
                                    travel: travel
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var PricingBlock_PricingBlock = (PricingBlock);

;// CONCATENATED MODULE: ./src/components/models/travel/PricingBlock/index.tsx



/***/ }),

/***/ 75238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ TestimonialsBlock_TestimonialsBlock; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(36690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ./src/components/models/travel/TestimonialsBlock/TestimonialsBlock.module.scss
var TestimonialsBlock_module = __webpack_require__(95056);
var TestimonialsBlock_module_default = /*#__PURE__*/__webpack_require__.n(TestimonialsBlock_module);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(32758);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(73117);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(35363);
// EXTERNAL MODULE: ./src/components/models/cms/blocks/TextWithIconBlock/index.ts + 1 modules
var TextWithIconBlock = __webpack_require__(54872);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next-i18next@12.0.1_@types+react@18.0.20_next@12.3.1_@babel+core@7.29.7_@types+react-do_eca48fcf8a6ebbff0d8681abd954f0c6/node_modules/next-i18next/dist/esm/index.js + 17 modules
var esm = __webpack_require__(84423);
;// CONCATENATED MODULE: ./src/components/models/travel/TestimonialsBlock/TestimonialsBlock.tsx








var TestimonialsBlock = function(param) {
    var testimonials = param.testimonials;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    if (!testimonials.length) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        className: (TestimonialsBlock_module_default()).root,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: "mb-4",
                    children: t("travel.testimonialTitle")
                }),
                testimonials.map(function(testimonial, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        md: 6,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextWithIconBlock/* default */.Z, (0,_object_spread/* default */.Z)({}, testimonial.contentBlock))
                    }, index);
                })
            ]
        })
    });
};
/* harmony default export */ var TestimonialsBlock_TestimonialsBlock = (TestimonialsBlock);

;// CONCATENATED MODULE: ./src/components/models/travel/TestimonialsBlock/index.tsx



/***/ }),

/***/ 76374:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ TravelExtensionTeaser_TravelExtensionTeaser; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ./src/components/models/travelExtension/TravelExtensionTeaser/TravelExtensionTeaser.module.scss
var TravelExtensionTeaser_module = __webpack_require__(2404);
var TravelExtensionTeaser_module_default = /*#__PURE__*/__webpack_require__.n(TravelExtensionTeaser_module);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next-i18next@12.0.1_@types+react@18.0.20_next@12.3.1_@babel+core@7.29.7_@types+react-do_eca48fcf8a6ebbff0d8681abd954f0c6/node_modules/next-i18next/dist/esm/index.js + 17 modules
var esm = __webpack_require__(84423);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/Button.js
var Button = __webpack_require__(10833);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/Modal.js + 6 modules
var Modal = __webpack_require__(73153);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/Card.js + 2 modules
var Card = __webpack_require__(48648);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(73117);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(35363);
// EXTERNAL MODULE: ./src/components/elements/media/CloudinaryImage/index.ts + 1 modules
var CloudinaryImage = __webpack_require__(42500);
// EXTERNAL MODULE: ./src/components/models/booking/BookingWizard/components/FullyBookedOverlay/index.ts + 1 modules
var FullyBookedOverlay = __webpack_require__(35073);
// EXTERNAL MODULE: ./src/components/models/booking/BookingWizard/steps/BookingStepAccommodation/ContingentBadge/index.ts + 1 modules
var ContingentBadge = __webpack_require__(91613);
;// CONCATENATED MODULE: ./src/components/models/travelExtension/TravelExtensionTeaser/TravelExtensionTeaser.tsx








var ModalWidget = function(param) {
    var extension = param.extension;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    var ref = (0,react.useState)(false), show = ref[0], setShow = ref[1];
    var handleClose = function() {
        return setShow(false);
    };
    var handleShow = function() {
        return setShow(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                variant: "signal",
                onClick: handleShow,
                className: (TravelExtensionTeaser_module_default()).detailsButton,
                "data-tr-click": "travel_page:travel_extension_detail_button:click",
                children: t("button.showMore")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
                show: show,
                onHide: handleClose,
                size: "lg",
                className: (TravelExtensionTeaser_module_default()).modal,
                centered: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Header */.Z.Header, {
                        closeButton: true,
                        className: (TravelExtensionTeaser_module_default()).header,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Title */.Z.Title, {
                            className: (TravelExtensionTeaser_module_default()).title,
                            children: extension.name
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Body */.Z.Body, {
                        className: (TravelExtensionTeaser_module_default()).body,
                        dangerouslySetInnerHTML: {
                            __html: extension.description
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Footer */.Z.Footer, {
                        className: (TravelExtensionTeaser_module_default()).footer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            variant: "light",
                            onClick: handleClose,
                            className: (TravelExtensionTeaser_module_default()).button,
                            children: t("button.close")
                        })
                    })
                ]
            })
        ]
    });
};
var TravelExtensionTeaser = function(param) {
    var extension = param.extension, priceText = param.priceText, _contingent = param.contingent, contingent = _contingent === void 0 ? 9999 : _contingent, buttonText = param.buttonText, buttonOnClick = param.buttonOnClick, buttonVariant = param.buttonVariant;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
            className: (TravelExtensionTeaser_module_default()).root,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            md: 4,
                            className: "pe-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "box-ratio-16-9",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "box-ratio-inner ".concat((TravelExtensionTeaser_module_default()).imgWrap),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloudinaryImage/* default */.Z, {
                                        image: extension.image,
                                        aspectRatio: 1.2,
                                        width: 720,
                                        responsive: false,
                                        className: "card-img"
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            md: 8,
                            className: "ps-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (TravelExtensionTeaser_module_default()).content,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContingentBadge/* default */.Z, {
                                        contingent: contingent,
                                        className: "position-absolute top-0 end-0 mt-1"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (TravelExtensionTeaser_module_default()).title,
                                        children: extension.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (TravelExtensionTeaser_module_default()).date,
                                        children: t("days", {
                                            count: extension.duration
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            className: (TravelExtensionTeaser_module_default()).list,
                                            children: extension.highlights.map(function(highlight, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: highlight.text
                                                }, index);
                                            })
                                        })
                                    }),
                                    buttonText && buttonOnClick ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (TravelExtensionTeaser_module_default()).bookingInfo,
                                        children: contingent > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                    variant: buttonVariant ? buttonVariant : "signal",
                                                    onClick: buttonOnClick,
                                                    className: (TravelExtensionTeaser_module_default()).customButton,
                                                    children: buttonText
                                                }),
                                                priceText !== undefined && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (TravelExtensionTeaser_module_default()).price,
                                                    children: priceText
                                                })
                                            ]
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalWidget, {
                                        extension: extension
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FullyBookedOverlay/* default */.Z, {
                    contingent: contingent
                })
            ]
        })
    });
};
/* harmony default export */ var TravelExtensionTeaser_TravelExtensionTeaser = (TravelExtensionTeaser);

;// CONCATENATED MODULE: ./src/components/models/travelExtension/TravelExtensionTeaser/index.ts



/***/ }),

/***/ 42380:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ TeamsBlock_TeamsBlock; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ./src/components/models/travelGuide/TeamsBlock/TeamsBlock.module.scss
var TeamsBlock_module = __webpack_require__(89437);
var TeamsBlock_module_default = /*#__PURE__*/__webpack_require__.n(TeamsBlock_module);
// EXTERNAL MODULE: ./src/components/cms/Title/index.tsx + 1 modules
var Title = __webpack_require__(31250);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(73117);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(35363);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(32758);
// EXTERNAL MODULE: ./src/components/models/travelGuide/TravelGuideTeaser/index.tsx + 1 modules
var TravelGuideTeaser = __webpack_require__(53249);
;// CONCATENATED MODULE: ./src/components/models/travelGuide/TeamsBlock/TeamsBlock.tsx





var buildContent = function(travelGuides) {
    var colSize = 4;
    switch(travelGuides.length){
        case 2:
        case 4:
            colSize = 6;
            break;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
        children: travelGuides.map(function(tourGuide, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                md: 6,
                xl: colSize,
                className: "mb-3",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TravelGuideTeaser/* default */.Z, {
                    travelGuide: tourGuide
                })
            }, index);
        })
    });
};
var TeamsBlock = function(param) {
    var teams = param.teams;
    if (teams.length) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    id: "teams",
                    className: "anchor"
                }),
                teams.map(function(team, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                        className: (TeamsBlock_module_default()).root,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* TitleH2 */.W, {
                                        title: team.name,
                                        overlap: true,
                                        className: (TeamsBlock_module_default()).title
                                    })
                                })
                            }),
                            buildContent(team.members)
                        ]
                    }, index);
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var TeamsBlock_TeamsBlock = (TeamsBlock);

;// CONCATENATED MODULE: ./src/components/models/travelGuide/TeamsBlock/index.tsx



/***/ }),

/***/ 10386:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ TravelGuideBlock_TravelGuideBlock; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ./src/components/models/travelGuide/TravelGuideBlock/TravelGuideBlock.module.scss
var TravelGuideBlock_module = __webpack_require__(9503);
var TravelGuideBlock_module_default = /*#__PURE__*/__webpack_require__.n(TravelGuideBlock_module);
// EXTERNAL MODULE: ./src/components/cms/Title/index.tsx + 1 modules
var Title = __webpack_require__(31250);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(73117);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(35363);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(32758);
// EXTERNAL MODULE: ./src/components/models/travelGuide/TravelGuideTeaser/index.tsx + 1 modules
var TravelGuideTeaser = __webpack_require__(53249);
// EXTERNAL MODULE: ./src/components/models/travelGuide/TravelGuideTeaserExtended/TravelGuideTeaserExtended.module.scss
var TravelGuideTeaserExtended_module = __webpack_require__(35087);
var TravelGuideTeaserExtended_module_default = /*#__PURE__*/__webpack_require__.n(TravelGuideTeaserExtended_module);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-bootstrap@2.5.0_@types+react@18.0.20_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-bootstrap/esm/Card.js + 2 modules
var Card = __webpack_require__(48648);
// EXTERNAL MODULE: ./src/components/elements/media/CloudinaryImage/index.ts + 1 modules
var CloudinaryImage = __webpack_require__(42500);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./src/app/providers/PrintConfigProvider.tsx
var PrintConfigProvider = __webpack_require__(3106);
;// CONCATENATED MODULE: ./src/components/models/travelGuide/TravelGuideTeaserExtended/TravelGuideTeaserExtended.tsx






var TravelGuideTeaserExtended = function(param) {
    var travelGuide = param.travelGuide;
    var printConfig = (0,react.useContext)(PrintConfigProvider/* PrintConfigContext */.E);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
        className: (TravelGuideTeaserExtended_module_default()).root,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                    xl: printConfig.isPrint ? 4 : 6,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "box-ratio-16-9",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "box-ratio-inner ".concat((TravelGuideTeaserExtended_module_default()).imgWrap),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloudinaryImage/* default */.Z, {
                                image: travelGuide.image,
                                altDefault: "".concat(travelGuide.firstName, " ").concat(travelGuide.lastName),
                                aspectRatio: 1.777,
                                responsive: false,
                                width: 635,
                                className: "card-img"
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                    xl: printConfig.isPrint ? 8 : 6,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Body */.Z.Body, {
                        className: (TravelGuideTeaserExtended_module_default()).cardBody,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Title */.Z.Title, {
                                className: (TravelGuideTeaserExtended_module_default()).cardTitle,
                                children: [
                                    travelGuide.firstName,
                                    " ",
                                    travelGuide.lastName
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Text */.Z.Text, {
                                as: "div",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (TravelGuideTeaserExtended_module_default()).description,
                                    dangerouslySetInnerHTML: {
                                        __html: travelGuide.description
                                    }
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var TravelGuideTeaserExtended_TravelGuideTeaserExtended = (TravelGuideTeaserExtended);

;// CONCATENATED MODULE: ./src/components/models/travelGuide/TravelGuideTeaserExtended/index.tsx


// EXTERNAL MODULE: ../../node_modules/.pnpm/next-i18next@12.0.1_@types+react@18.0.20_next@12.3.1_@babel+core@7.29.7_@types+react-do_eca48fcf8a6ebbff0d8681abd954f0c6/node_modules/next-i18next/dist/esm/index.js + 17 modules
var esm = __webpack_require__(84423);
;// CONCATENATED MODULE: ./src/components/models/travelGuide/TravelGuideBlock/TravelGuideBlock.tsx









var buildContent = function(tourGuides, isPrint) {
    if (isPrint) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: tourGuides.map(function(tourGuide, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                    className: "mb-3",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TravelGuideTeaserExtended_TravelGuideTeaserExtended, {
                            travelGuide: tourGuide
                        })
                    })
                }, index);
            })
        });
    }
    switch(tourGuides.length){
        case 1:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                children: tourGuides.map(function(tourGuide, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TravelGuideTeaserExtended_TravelGuideTeaserExtended, {
                            travelGuide: tourGuide
                        })
                    }, index);
                })
            });
        case 2:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                children: tourGuides.map(function(tourGuide, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        md: 6,
                        className: "mb-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TravelGuideTeaser/* default */.Z, {
                            travelGuide: tourGuide
                        })
                    }, index);
                })
            });
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                children: tourGuides.map(function(tourGuide, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        md: 6,
                        lg: 4,
                        className: "mb-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TravelGuideTeaser/* default */.Z, {
                            travelGuide: tourGuide
                        })
                    }, index);
                })
            });
    }
};
var TravelGuideBlock = function(param) {
    var travelGuides = param.travelGuides, _titleOverlap = param.titleOverlap, titleOverlap = _titleOverlap === void 0 ? true : _titleOverlap;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    var printConfig = (0,react.useContext)(PrintConfigProvider/* PrintConfigContext */.E);
    if (travelGuides.length) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            className: (TravelGuideBlock_module_default()).root,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    id: "guides",
                    className: "anchor"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                    className: (TravelGuideBlock_module_default()).titleRow,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            xs: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* TitleH2 */.W, {
                                title: t("travel.travelGuide"),
                                overlap: titleOverlap,
                                className: (TravelGuideBlock_module_default()).title
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            xs: 12,
                            children: buildContent(travelGuides, printConfig.isPrint)
                        })
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var TravelGuideBlock_TravelGuideBlock = (TravelGuideBlock);

;// CONCATENATED MODULE: ./src/components/models/travelGuide/TravelGuideBlock/index.tsx



/***/ }),

/***/ 51912:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"StarRatingDisplay_root__U3uBg","star":"StarRatingDisplay_star__wGWu4","half":"StarRatingDisplay_half__fZvUJ"};

/***/ }),

/***/ 58948:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"AccommodationBlock_root__Q0sAG"};

/***/ }),

/***/ 83927:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"AccommodationAvailableAddons_title__SQX9t"};

/***/ }),

/***/ 51743:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"AccommodationDetailed_root___KA_6","cardBody":"AccommodationDetailed_cardBody__3r1gx","stars":"AccommodationDetailed_stars__FOEK4","title":"AccommodationDetailed_title___sNwG","roomTypeWrap":"AccommodationDetailed_roomTypeWrap__X7yrG","imgWrap":"AccommodationDetailed_imgWrap__FvhB3","galleryContainer":"AccommodationDetailed_galleryContainer__YLpjs"};

/***/ }),

/***/ 10979:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"AccommodationRoomType_root__shPV7","cardTitle":"AccommodationRoomType_cardTitle__X_7yu","cardBody":"AccommodationRoomType_cardBody__mStcS","imgWrap":"AccommodationRoomType_imgWrap__n76V8"};

/***/ }),

/***/ 16444:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"badge":"ContingentBadge_badge__O2x89"};

/***/ }),

/***/ 13625:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"ItineraryAccordion_root__RnoxX","header":"ItineraryAccordion_header__OBtQy","dateHeading":"ItineraryAccordion_dateHeading__wLqa_","accordion":"ItineraryAccordion_accordion__LawEI","dateWrap":"ItineraryAccordion_dateWrap__IKfLn","image":"ItineraryAccordion_image__LI34W","imageCol":"ItineraryAccordion_imageCol__XY74W"};

/***/ }),

/***/ 47937:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"ItineraryBlock_root__L1VR6","programText":"ItineraryBlock_programText__81xn8","accordionCol":"ItineraryBlock_accordionCol__ai3aG","mapCol":"ItineraryBlock_mapCol__FP_sM","accordionWrap":"ItineraryBlock_accordionWrap__m_PdJ","programDisclaimer":"ItineraryBlock_programDisclaimer__J48kn"};

/***/ }),

/***/ 65385:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"GalleryBlock_root__ENXuO"};

/***/ }),

/***/ 88372:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"HeaderBlock_root__XUkFW","tile":"HeaderBlock_tile__qiu_w","content":"HeaderBlock_content__n_58w","title":"HeaderBlock_title__HzmLc","text":"HeaderBlock_text__8_REc","ribbonWrap":"HeaderBlock_ribbonWrap__cWBSL"};

/***/ }),

/***/ 52604:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"HeaderBlockInfoLabel_root__Db9r_","infoLabelCustomButton":"HeaderBlockInfoLabel_infoLabelCustomButton__bexCa"};

/***/ }),

/***/ 89952:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"IntroBlock_root__EEWdh"};

/***/ }),

/***/ 43394:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"IntroBlockHighlights_root__bhUjC","title":"IntroBlockHighlights_title__BLuyS","inner":"IntroBlockHighlights_inner__7rj_d","list":"IntroBlockHighlights_list__g0cQ6"};

/***/ }),

/***/ 62100:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"IntroBlockLeadText_root__SOi7Y","title":"IntroBlockLeadText_title__FLqIw","text":"IntroBlockLeadText_text__Wu0hd","travelType":"IntroBlockLeadText_travelType__LO2GB","videoWrapper":"IntroBlockLeadText_videoWrapper__Sh7px","videoIframe":"IntroBlockLeadText_videoIframe__6mQaR","partner":"IntroBlockLeadText_partner__H4GMV","label":"IntroBlockLeadText_label__m4Wa6","item":"IntroBlockLeadText_item__yZ6b_"};

/***/ }),

/***/ 78674:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"PricingBlockServices_root__P0NIH","title":"PricingBlockServices_title__OAkY8","included":"PricingBlockServices_included__g_aDz"};

/***/ }),

/***/ 95056:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"TestimonialsBlock_root__pkTxH"};

/***/ }),

/***/ 2404:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modal":"TravelExtensionTeaser_modal__sat_6","header":"TravelExtensionTeaser_header__Vs4Tk","title":"TravelExtensionTeaser_title__mb8fd","body":"TravelExtensionTeaser_body__Gpwsd","footer":"TravelExtensionTeaser_footer__yPzvL","button":"TravelExtensionTeaser_button__0oyjs","root":"TravelExtensionTeaser_root__JbsKl","imgWrap":"TravelExtensionTeaser_imgWrap__XXgOc","content":"TravelExtensionTeaser_content__tTK6T","date":"TravelExtensionTeaser_date__2VyGa","list":"TravelExtensionTeaser_list__7Uaog","bookingInfo":"TravelExtensionTeaser_bookingInfo__erdDY","price":"TravelExtensionTeaser_price__hNWJn","customButton":"TravelExtensionTeaser_customButton__KP7RY","detailsButton":"TravelExtensionTeaser_detailsButton___JmYq"};

/***/ }),

/***/ 89437:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"TeamsBlock_root__gSOB1","title":"TeamsBlock_title__YAA7p"};

/***/ }),

/***/ 9503:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"TravelGuideBlock_root__E3eLb","title":"TravelGuideBlock_title__Nn7AI"};

/***/ }),

/***/ 35087:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"TravelGuideTeaserExtended_root__C9ciG","cardBody":"TravelGuideTeaserExtended_cardBody__GtXiE","cardTitle":"TravelGuideTeaserExtended_cardTitle__Q5oAx","imgWrap":"TravelGuideTeaserExtended_imgWrap___Wrd7","description":"TravelGuideTeaserExtended_description__rT71W","qaItem":"TravelGuideTeaserExtended_qaItem__lo0bF","iconWrap":"TravelGuideTeaserExtended_iconWrap__rSCRH","question":"TravelGuideTeaserExtended_question__HhU_K"};

/***/ }),

/***/ 8174:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"PricingBlock_root__YHSBC","title":"PricingBlock_title__HGxbK"};

/***/ }),

/***/ 73587:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"PricingBlockInfo_root__hSkln","prices":"PricingBlockInfo_prices__ik8SG","inner":"PricingBlockInfo_inner__CHZ43","pricingTableWrap":"PricingBlockInfo_pricingTableWrap__QXCWZ","package":"PricingBlockInfo_package__1N_hs","item":"PricingBlockInfo_item__bhsXw","pricingInfo":"PricingBlockInfo_pricingInfo__gOZx8"};

/***/ })

}]);